<template>
  <div class="elencotipocliente">
    <b-container fluid>
      <b-row class="headerbox">
        <b-col>
          <h5>Lista Tipologie di Cliente</h5>
        </b-col>
      </b-row>
      <br>
      <b-row>
        <b-col md="5">
          <b-form-group label-cols-sm="2" label="Cerca">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Cerca" />
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''"><font-awesome-icon icon="times-circle" /></b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col v-if="stato.admin">
          <b-button variant="success" style="float: right" to="/elenco/tipocliente/aggiungi"><font-awesome-icon icon="plus-circle" /> Aggiungi tipologia di cliente</b-button>
        </b-col>
      </b-row>
      <br>
      <b-row>
        <b-col>
          <b-table
            :striped="true"
            :hover="true"
            :responsive="true"
            :items="lista"
            :fields="campi"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            @filtered="onFiltered"
          >
            <template slot="action" slot-scope="row">
              <b-button v-if="stato.admin" size="sm" variant="danger" v-on:click="openModalDeleteCliente(row.item)"><font-awesome-icon icon="trash-alt" /></b-button>
              <b-button v-if="stato.admin" size="sm" style="margin-left: 10px;" :to="'/elenco/tipocliente/modifica/'+row.item.id"><font-awesome-icon icon="edit" /></b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            align="center"
          />
        </b-col>
      </b-row>
    </b-container>

    <b-modal v-model="modal.delete" title="Conferma richiesta di eliminazione!">
      <p>Sei sicuro di voler eliminare <strong>{{modalData.delete.nome}}</strong>?</p>
      <div slot="modal-footer">
        <b-button class="float-right" variant="danger" style="margin-left: 10px" v-on:click="deleteCliente(modalData.delete.id)">Si</b-button>
        <b-button class="float-right" v-on:click="modal.delete = false">No</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  name: 'elencotipocliente',
  data() {
    return {
      lista: [],
      campi: [
        {key: 'nome', label: 'Nome', sortable: true},
        {key: 'note', label: 'Note', sortable: true},
        {key: 'action', label: '', sortable: false}
      ],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      filter: null,
      modal: {
        delete: false
      },
      modalData: {
        delete: {}
      }
    }
  },
  created: function(){
    this.getListaTipiClienti()
  },
  methods: {
    getListaTipiClienti(){
      Vue.http.post('elenco/tipocliente', {}, {credentials : true}).then(response => {
        if(response.body.success){
            this.lista = response.body.list
            this.totalRows = this.lista.length
        }else{
          this.lista = []
          /*Vue.notify({
              group: 'global',
              title: 'Errore',
              text: "Lista Tipologie di alimentazione elettrica non caricata correttamente.",
              type: 'error'
          })*/
        }
      }, response => {})
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    openModalDeleteCliente(item){
      this.modalData.delete = item
      this.modal.delete = true
    },
    deleteCliente(id){
      Vue.http.post('elenco/tipocliente/delete/'+id, {}, {credentials : true}).then(response => {
        if(response.body.success){
          this.getListaTipiClienti()
          
          this.modal.delete = false
          this.modalData.delete = {}

          Vue.notify({
              group: 'global',
              title: 'Operazione eseguita!',
              text: "Tipologia di cliente installazione eliminato correttamente.",
              type: 'success'
          })
        }else{
          Vue.notify({
              group: 'global',
              title: 'Errore',
              text: response.body.msg,
              type: 'error'
          })
        }
      }, response => {})
    }
  },
  computed: {
    ...mapGetters(['stato'])
  }
}
</script>


<style>
</style>